import { search } from '../searchService';
import { post, put, del, getById } from '../apiService';
import type { AdditionalContent } from '../../types/content/additionalContent';
import type { SearchParams } from '../../types/search';

export async function searchAdditionalContent(
  filter: object = {},
  params: SearchParams = {},
): Promise<AdditionalContent[]> {
  return search<AdditionalContent>('/additional-content/search', filter, params);
}

export async function getAdditionalContentById(id: string): Promise<AdditionalContent> {
  return getById<AdditionalContent>('/additional-content', id);
}

export async function createAdditionalContent(data: Partial<AdditionalContent>): Promise<AdditionalContent> {
  return post<AdditionalContent>('/additional-content', data);
}

export async function updateAdditionalContent(id: string, data: AdditionalContent): Promise<AdditionalContent> {
  return put<AdditionalContent>(`/additional-content/${id}`, data);
}

export async function deleteAdditionalContent(id: string): Promise<void> {
  return del<void>(`/additional-content/${id}`);
}
